import * as XLSX from 'xlsx';

/**
 * Lot 3.5d-3 (D1, E165) — le fichier Excel de la TRANSMISSION AU CFA, fabriqué PAR LE NAVIGATEUR.
 * Le serveur n'a aucune bibliothèque Excel (en ajouter une tue le backend au déploiement) : il fournit les
 * en-têtes et les VALEURS (`fichier` du brouillon, ou les lignes cochées), le navigateur les met en classeur.
 * Le serveur reconnaît le fichier reçu (archive .xlsx, taille) et garde son empreinte ; il n'en garde jamais le contenu.
 *
 * `spec = { nom, feuille, entetes: [..], lignes: [[..], ..] }`
 */
function classeur(spec) {
    const feuille = XLSX.utils.aoa_to_sheet([spec.entetes, ...spec.lignes]);
    // Largeur de chaque colonne d'après son contenu le plus long (10 à 40 caractères) : le CFA lit sans élargir.
    feuille['!cols'] = spec.entetes.map((e, i) => ({
        wch: Math.min(40, Math.max(10, String(e).length + 2, ...spec.lignes.map((l) => String(l[i] ?? '').length + 2)))
    }));
    const c = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(c, feuille, spec.feuille || 'Tuteurs');
    return c;
}

/** Le classeur en base64, tel qu'il voyage vers le serveur pour être joint. */
export function fabriquerXlsx(spec) {
    return XLSX.write(classeur(spec), { type: 'base64', bookType: 'xlsx' });
}

/** « Télécharger » (et le secours messagerie, où le fichier se joint à la main). */
export function telechargerXlsx(spec) {
    XLSX.writeFile(classeur(spec), spec.nom);
}
